// import cloneDeep from 'lodash.clonedeep';
import {
  convertDateStringToISODate
  // dateFormat
} from 'common/helpers/dateHelper';
import {
  convertStringToInteger,
  convertStringToFloat
} from 'common/helpers/numberHelper';

export const transformMetaData = (values, c7Form, customerMetaData) => {
  const newMetaDataObject = {};
  const { code } = c7Form;
  // const newValues = cloneDeep(values);
  const newValues = { ...values };
  if (!customerMetaData || !customerMetaData.data) {
    return null;
  }
  const metaDataIds = Object.keys(customerMetaData.data);
  const metaDataArray = metaDataIds.map((id) => customerMetaData.data[id]);
  if (c7Form?.metaDataAttributes) {
    c7Form.metaDataAttributes.forEach((metaDataCode) => {
      const metaDataElement = metaDataArray.find(
        (metaData) => metaData.code === metaDataCode
      );
      if (metaDataElement) {
        if (metaDataElement.dataType === 'Checkbox') {
          let newValue;
          metaDataElement.options.forEach((option) => {
            if (values[`metaData-${code}-${metaDataElement.id}-${option}`]) {
              if (newValue) {
                newValue += `${option},`;
              } else {
                newValue = `${option},`;
              }
            }
          });
          if (newValue) {
            // trim last comma and space;
            newValues[`metaData-${code}-${metaDataElement.id}`] =
              newValue.substring(0, newValue.length - 1);
          } else {
            newValues[`metaData-${code}-${metaDataElement.id}`] = '';
          }
        }

        if (newValues[`metaData-${code}-${metaDataElement.id}`]) {
          let value = newValues[`metaData-${code}-${metaDataElement.id}`];
          switch (metaDataElement.dataType) {
            case 'Number': {
              value = value && convertStringToFloat(value);
              break;
            }

            case 'Integer': {
              value = value && convertStringToInteger(value);
              break;
            }
            case 'Date Picker': {
              try {
                value = value && convertDateStringToISODate(value);
              } catch {
                // fail silently
              }
              break;
            }
            case 'True / False': {
              value = value === 'True';
              break;
            }
            case 'Yes / No': {
              value = value === 'Yes';
              break;
            }
            default:
              break;
          }
          // const newMetaData = {
          //   id,
          //   code: metaDataElement.code,
          //   value
          // };
          newMetaDataObject[metaDataCode] = value;
        }
      }
    });
  }

  return newMetaDataObject;
};

export const transformQuestions = (values, c7Form) => {
  const newobject = {};
  // const newValues = cloneDeep(values);
  const newValues = { ...values };
  if (c7Form.questions) {
    c7Form.questions.forEach((question) => {
      if (question.dataType === 'Checkbox') {
        let newValue;
        question.options.forEach((option) => {
          if (values[`question-${question.id}-${option}`]) {
            if (newValue) {
              newValue += `${option},`;
            } else {
              newValue = `${option},`;
            }
          }
        });
        if (newValue) {
          // trim last comma and space;
          newValues[`question-${question.id}`] = newValue.substring(
            0,
            newValue.length - 1
          );
        } else {
          newValues[`question-${question.id}`] = '';
        }
      }

      if (newValues[`question-${question.id}`]) {
        let value = newValues[`question-${question.id}`];
        switch (question.dataType) {
          case 'Number': {
            value = value && convertStringToFloat(value);
            break;
          }

          case 'Integer': {
            value = value && convertStringToInteger(value);
            break;
          }
          case 'Date Picker': {
            try {
              value = value && convertDateStringToISODate(value);
            } catch {
              // Fail silently
            }
            break;
          }
          case 'True / False': {
            value = value === 'True';
            break;
          }
          case 'Yes / No': {
            value = value === 'Yes';
            break;
          }
          default:
            break;
        }
        // const newMetaData = {
        //   id,
        //   code: metaDataElement.code,
        //   value
        // };
        newobject[question.code] = value;
      }
    });
  }

  return newobject;
};
